import { useApiData } from '@/composables/useApiData';

export const useApiProfile = () => {
  const apiProfileData = useApiData('profile');
  const lang = navigator.language?.[0] ? navigator.language : 'en-US';

  async function getDefaultSettings(options) {

    const requestOptions = {
      ...options,
      code: lang
    }

    return await apiProfileData.request('getDefaultSettings', requestOptions)
  }

  return { getDefaultSettings }
}
